var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Accordion",
    [
      _c(
        "AccordionItem",
        [
          _c("template", { slot: "accordion-trigger" }, [
            _c("strong", [_vm._v("Personal Details")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                _vm._s(
                  _vm.jobApplication.user.personal_details_percent_complete
                ) + "% "
              ),
              _vm.jobApplication.user.personal_details_percent_complete == 100
                ? _c("i", {
                    staticClass: "fa fa-check",
                    staticStyle: { color: "#6ABC45" }
                  })
                : _vm._e()
            ])
          ]),
          _vm._v(" "),
          _c(
            "template",
            { slot: "accordion-content" },
            [
              _c("LoadingCvPersonalDetails", {
                attrs: {
                  "job-application": _vm.jobApplication,
                  "div-class": _vm.divClass
                }
              })
            ],
            1
          )
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "AccordionItem",
        [
          _c("template", { slot: "accordion-trigger" }, [
            _c("strong", [_vm._v("CV Details")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                _vm._s(_vm.jobApplication.user.cv_details_percent_complete) +
                  "% "
              ),
              _vm.jobApplication.user.cv_details_percent_complete == 100
                ? _c("i", {
                    staticClass: "fa fa-check",
                    staticStyle: { color: "#6ABC45" }
                  })
                : _vm._e()
            ])
          ]),
          _vm._v(" "),
          _c("template", { slot: "accordion-content" }, [
            _vm.jobApplication.user.user_detail !== null
              ? _c("div", { staticClass: "grid-x grid-padding-x" }, [
                  _c("div", { staticClass: "cell small-12" }, [
                    _c("h3", [_vm._v("Languages")])
                  ]),
                  _vm._v(" "),
                  _vm.jobApplication.user.user_detail !== null &&
                  _vm.jobApplication.user.user_detail.language_proficiencies !==
                    undefined
                    ? _c(
                        "div",
                        _vm._l(
                          _vm.jobApplication.user.user_detail
                            .language_proficiencies,
                          function(cvLanguage, index) {
                            return _c(
                              "div",
                              {
                                key: "lang" + index,
                                staticClass: "cell small-12"
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "grid-x grid-padding-x" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "form-control cell small-6"
                                      },
                                      [
                                        _c("label", [_vm._v("Language")]),
                                        _vm._v(" "),
                                        _c("input", {
                                          attrs: { type: "text", disabled: "" },
                                          domProps: {
                                            value: cvLanguage.language.title
                                          }
                                        })
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "form-control cell small-6"
                                      },
                                      [
                                        _c("label", [_vm._v("Fluency")]),
                                        _vm._v(" "),
                                        _c("input", {
                                          attrs: { type: "text", disabled: "" },
                                          domProps: {
                                            value: cvLanguage.fluency
                                          }
                                        })
                                      ]
                                    )
                                  ]
                                )
                              ]
                            )
                          }
                        ),
                        0
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "cell small-12 mt-5" }, [
                    _c("h3", [_vm._v("Education")])
                  ]),
                  _vm._v(" "),
                  _vm.jobApplication.user.user_detail !== null &&
                  _vm.jobApplication.user.user_detail.qualifications !==
                    undefined
                    ? _c(
                        "div",
                        _vm._l(
                          _vm.jobApplication.user.user_detail.qualifications,
                          function(cvEducation, index) {
                            return _c(
                              "div",
                              {
                                key: "edu" + index,
                                staticClass: "cell small-12"
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "grid-x grid-padding-x" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "form-control cell small-12"
                                      },
                                      [
                                        _c("label", [
                                          _vm._v("Highest Level of Education")
                                        ]),
                                        _vm._v(" "),
                                        _c("input", {
                                          attrs: { type: "text", disabled: "" },
                                          domProps: {
                                            value:
                                              cvEducation.qualification_level
                                                .title
                                          }
                                        })
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "form-control cell small-12"
                                      },
                                      [
                                        _c("label", [
                                          _vm._v("Type of Institution")
                                        ]),
                                        _vm._v(" "),
                                        _c("input", {
                                          attrs: { type: "text", disabled: "" },
                                          domProps: {
                                            value: cvEducation.institution_type
                                              ? cvEducation.institution_type
                                                  .type
                                              : ""
                                          }
                                        })
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "form-control cell small-12"
                                      },
                                      [
                                        _c("label", [_vm._v("Institution")]),
                                        _vm._v(" "),
                                        _c("input", {
                                          attrs: { type: "text", disabled: "" },
                                          domProps: {
                                            value: cvEducation.institution_title
                                          }
                                        })
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "form-control cell small-12"
                                      },
                                      [
                                        _c("label", [_vm._v("Field of Study")]),
                                        _vm._v(" "),
                                        _c("input", {
                                          attrs: { type: "text", disabled: "" },
                                          domProps: {
                                            value: cvEducation.subjects[0]
                                              ? cvEducation.subjects[0].title
                                              : ""
                                          }
                                        })
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "form-control cell small-12"
                                      },
                                      [
                                        _c("label", [_vm._v("Course Studied")]),
                                        _vm._v(" "),
                                        _c("input", {
                                          attrs: { type: "text", disabled: "" },
                                          domProps: {
                                            value: cvEducation.course_studied
                                          }
                                        })
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "form-control cell small-12",
                                        staticStyle: {
                                          "padding-bottom": "12px"
                                        }
                                      },
                                      [
                                        _c("label", [_vm._v("Documents")]),
                                        _vm._v(" "),
                                        _c(
                                          "ul",
                                          _vm._l(
                                            cvEducation.qualification_documents,
                                            function(
                                              qualification_document,
                                              idx
                                            ) {
                                              return _c("li", { key: idx }, [
                                                _c(
                                                  "a",
                                                  {
                                                    attrs: {
                                                      href:
                                                        qualification_document.path_cdn
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        qualification_document.path_cdn
                                                      )
                                                    )
                                                  ]
                                                )
                                              ])
                                            }
                                          ),
                                          0
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ]
                            )
                          }
                        ),
                        0
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "cell small-12 mt-5" }, [
                    _c("h3", [_vm._v("Work Experience")])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "cell small-11 ml-20" },
                    [
                      _c(
                        "Accordion",
                        _vm._l(
                          _vm.jobApplication.user.user_detail.user_detail_jobs,
                          function(cvWorkExp, index) {
                            return _c(
                              "AccordionItem",
                              { key: "work" + index },
                              [
                                _c("template", { slot: "accordion-trigger" }, [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(cvWorkExp.employer) +
                                        " (" +
                                        _vm._s(
                                          _vm.convertDate(
                                            cvWorkExp.start_date,
                                            "MMMM YYYY"
                                          )
                                        ) +
                                        " - " +
                                        _vm._s(
                                          _vm.convertDate(
                                            cvWorkExp.end_date,
                                            "MMMM YYYY"
                                          )
                                        ) +
                                        ")"
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("template", { slot: "accordion-content" }, [
                                  _c("div", { staticClass: "cell small-12" }, [
                                    !cvWorkExp.is_gap
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "grid-x grid-padding-x"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "form-control cell small-12"
                                              },
                                              [
                                                _c("label", [
                                                  _vm._v(
                                                    "Company/Institution Name"
                                                  )
                                                ]),
                                                _vm._v(" "),
                                                _c("input", {
                                                  attrs: {
                                                    type: "text",
                                                    disabled: ""
                                                  },
                                                  domProps: {
                                                    value: cvWorkExp.employer
                                                  }
                                                })
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "form-control cell small-12"
                                              },
                                              [
                                                _c("label", [
                                                  _vm._v("Industry")
                                                ]),
                                                _vm._v(" "),
                                                _c("input", {
                                                  attrs: {
                                                    type: "text",
                                                    disabled: ""
                                                  },
                                                  domProps: {
                                                    value:
                                                      "(cvWorkExp.industry !== undefined) ? cvWorkExp.industry.title : ''"
                                                  }
                                                })
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "form-control cell small-12"
                                              },
                                              [
                                                _c("label", [_vm._v("Role")]),
                                                _vm._v(" "),
                                                _c("input", {
                                                  attrs: {
                                                    type: "text",
                                                    disabled: ""
                                                  },
                                                  domProps: {
                                                    value:
                                                      cvWorkExp.role !== null
                                                        ? cvWorkExp.role.title
                                                        : ""
                                                  }
                                                })
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "form-control cell small-12"
                                              },
                                              [
                                                _c("label", [
                                                  _vm._v("Responsibilities")
                                                ]),
                                                _vm._v(" "),
                                                _c("input", {
                                                  attrs: {
                                                    type: "text",
                                                    disabled: ""
                                                  },
                                                  domProps: {
                                                    value:
                                                      cvWorkExp.responsibilities
                                                  }
                                                })
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "form-control cell small-12"
                                              },
                                              [
                                                _c("label", [
                                                  _vm._v(
                                                    "Industry specific qualifications"
                                                  )
                                                ]),
                                                _vm._v(" "),
                                                _c("input", {
                                                  attrs: {
                                                    type: "text",
                                                    disabled: ""
                                                  },
                                                  domProps: {
                                                    value:
                                                      cvWorkExp.industry_qualifications
                                                  }
                                                })
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "form-control cell small-12"
                                              },
                                              [
                                                _c("label", [
                                                  _vm._v("Start Date")
                                                ]),
                                                _vm._v(" "),
                                                _c("input", {
                                                  attrs: {
                                                    type: "text",
                                                    disabled: ""
                                                  },
                                                  domProps: {
                                                    value: cvWorkExp.start_date
                                                  }
                                                })
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "form-control cell small-12"
                                              },
                                              [
                                                _c("label", [
                                                  _vm._v("End Date")
                                                ]),
                                                _vm._v(" "),
                                                _c("input", {
                                                  attrs: {
                                                    type: "text",
                                                    disabled: ""
                                                  },
                                                  domProps: {
                                                    value: cvWorkExp.end_date
                                                  }
                                                })
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "form-control cell small-12"
                                              },
                                              [
                                                _c("label", [
                                                  _vm._v("Reason for leaving")
                                                ]),
                                                _vm._v(" "),
                                                cvWorkExp.reason_for_leaving !==
                                                "other"
                                                  ? _c("input", {
                                                      attrs: {
                                                        type: "text",
                                                        disabled: ""
                                                      },
                                                      domProps: {
                                                        value:
                                                          cvWorkExp.reason_for_leaving
                                                      }
                                                    })
                                                  : _c("input", {
                                                      attrs: {
                                                        type: "text",
                                                        disabled: ""
                                                      },
                                                      domProps: {
                                                        value:
                                                          cvWorkExp.other_reason_for_leaving
                                                      }
                                                    })
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "form-control cell small-12"
                                              },
                                              [
                                                _c("hr", {
                                                  staticStyle: {
                                                    "max-width": "unset"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "form",
                                                  { attrs: { method: "post" } },
                                                  [
                                                    _c("input", {
                                                      attrs: {
                                                        type: "hidden",
                                                        name: "_csrfToken"
                                                      },
                                                      domProps: {
                                                        value: _vm.csrfToken
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c("label", [
                                                      _vm._v("Recruiter's Note")
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("input", {
                                                      attrs: {
                                                        type: "text",
                                                        name: "recruiter_notes"
                                                      },
                                                      domProps: {
                                                        value:
                                                          cvWorkExp.recruiter_notes
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c("input", {
                                                      attrs: {
                                                        type: "hidden",
                                                        name: "id"
                                                      },
                                                      domProps: {
                                                        value: cvWorkExp.id
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c("div", [
                                                      _c(
                                                        "button",
                                                        {
                                                          staticClass: "button",
                                                          attrs: {
                                                            type: "submit",
                                                            name:
                                                              "work_experience_recruiter_notes",
                                                            value:
                                                              "work_experience_recruiter_notes"
                                                          }
                                                        },
                                                        [_vm._v("Submit")]
                                                      )
                                                    ])
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ])
                                ])
                              ],
                              2
                            )
                          }
                        ),
                        1
                      )
                    ],
                    1
                  )
                ])
              : _c("div", [
                  _c("p", [
                    _vm._v(
                      "\n                    Details info for this user is not available "
                    ),
                    _c("br")
                  ])
                ])
          ])
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "AccordionItem",
        [
          _c("template", { slot: "accordion-trigger" }, [
            _c("strong", [_vm._v("Printed CV")])
          ]),
          _vm._v(" "),
          _c("template", { slot: "accordion-content" }, [
            _c("div", { staticClass: "cell small-12" }, [
              _c("iframe", {
                attrs: {
                  src: "" + _vm.jobApplication.user.cv_url,
                  width: "100%",
                  height: "1000px"
                }
              })
            ])
          ])
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "AccordionItem",
        [
          _c("template", { slot: "accordion-trigger" }, [
            _c("strong", [_vm._v("Personal CV")])
          ]),
          _vm._v(" "),
          _c("template", { slot: "accordion-content" }, [
            _c("div", { staticClass: "cell small-12" }, [
              _vm.jobApplication.user.personal_cv_url
                ? _c("iframe", {
                    attrs: {
                      src: "" + _vm.jobApplication.user.personal_cv_url,
                      width: "100%",
                      height: "1000px"
                    }
                  })
                : _c("div", [
                    _c("p", [
                      _vm._v(
                        "\n                        No Personal CV Available\n                    "
                      )
                    ])
                  ])
            ])
          ])
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "AccordionItem",
        [
          _c("template", { slot: "accordion-trigger" }, [
            _c("strong", [_vm._v("Consent")]),
            _vm._v(" "),
            _c("small", [
              _vm._v(
                _vm._s(
                  _vm.jobApplication.user.agree_to_marketing ? "Yes" : "No"
                )
              )
            ])
          ]),
          _vm._v(" "),
          _c("template", { slot: "accordion-content" }, [
            _vm._v(
              "\n            " +
                _vm._s(
                  _vm.jobApplication.user.agree_to_marketing ? "Yes" : "No"
                ) +
                "\n        "
            )
          ])
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "AccordionItem",
        [
          _c("template", { slot: "accordion-trigger" }, [
            _c("strong", [_vm._v("AIMS")])
          ]),
          _vm._v(" "),
          _c(
            "template",
            { slot: "accordion-content" },
            [
              _c("LoadingCvAims", {
                attrs: {
                  "user-detail": _vm.jobApplication.user.user_detail,
                  module: _vm.module,
                  "trait-statements-by-cluster": _vm.traitStatementsByCluster
                }
              })
            ],
            1
          )
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "AccordionItem",
        [
          _c("template", { slot: "accordion-trigger" }, [
            _c("strong", [_vm._v("Ifacts Form")])
          ]),
          _vm._v(" "),
          _c("template", { slot: "accordion-content" }, [
            _vm.jobApplication.ifact_form
              ? _c("div", { staticClass: "ifact-loading-cv" }, [
                  _c("div", { staticClass: "grid-x grid-padding-x" }, [
                    _vm.jobApplication.ifact_form.document_url
                      ? _c("div", { staticClass: "col auto form" }, [
                          _vm._v(
                            "\n                        Upload Manually.\n                    "
                          )
                        ])
                      : _c("div", { staticClass: "cell auto form" }, [
                          _vm._v(
                            "\n                        I, the undersigned (full name) "
                          ),
                          _c("div", { staticClass: "form-label" }, [
                            _vm._v(
                              _vm._s(_vm.jobApplication.ifact_form.first_name)
                            )
                          ]),
                          _vm._v("       (surename)"),
                          _c("div", { staticClass: "form-label" }, [
                            _vm._v(
                              _vm._s(_vm.jobApplication.ifact_form.surename)
                            )
                          ]),
                          _vm._v("       (maiden name)"),
                          _c("div", { staticClass: "form-label" }, [
                            _vm._v(
                              _vm._s(_vm.jobApplication.ifact_form.maiden_name)
                            )
                          ]),
                          _c("br"),
                          _vm._v("\n                        ID Number "),
                          _c("div", { staticClass: "form-label" }, [
                            _vm._v(
                              _vm._s(_vm.jobApplication.ifact_form.id_number)
                            )
                          ]),
                          _vm._v(
                            " (If not available, date of birth & passport number)"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n                        Have you ever been convicted of an offence? "
                          ),
                          _c("div", { staticClass: "form-label" }, [
                            _vm._v(
                              _vm._s(
                                _vm.jobApplication.ifact_form.is_ever_convicted
                                  ? "Yes"
                                  : "No"
                              )
                            )
                          ]),
                          _c("br"),
                          _vm._v(
                            "\n                        If so state the place, date and sentence. "
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "form-label",
                              staticStyle: { width: "auto !important" }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.jobApplication.ifact_form
                                    .conviction_details
                                )
                              )
                            ]
                          ),
                          _c("br")
                        ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "grid-x grid-padding-x mt-3" }, [
                    !_vm.jobApplication.ifact_form.document_url
                      ? _c("div", { staticClass: "col auto form" }, [
                          _c(
                            "a",
                            {
                              attrs: {
                                href:
                                  "/recruiter/active-requisitions/ifact-form/" +
                                  _vm.jobApplication.id,
                                target: "_blank"
                              }
                            },
                            [_vm._v("View Full Form")]
                          ),
                          _vm._v(" |\n                        "),
                          _c(
                            "a",
                            {
                              attrs: {
                                href:
                                  "/candidate/ifact-form/download/" +
                                  _vm.jobApplication.id +
                                  ".pdf",
                                target: "_blank"
                              }
                            },
                            [_vm._v("Download Form")]
                          ),
                          _vm._v(
                            " | Last modified: " +
                              _vm._s(
                                _vm.convertDate(
                                  _vm.jobApplication.ifact_form.modified
                                )
                              ) +
                              "\n                    "
                          )
                        ])
                      : _c(
                          "div",
                          { staticClass: "cell auto form ifact-form-upload" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "grid-x grid-padding-x align-items-center"
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "cell shrink" },
                                  [
                                    _c("ifact-form-upload-modal", {
                                      ref: "uploadIfactForm",
                                      attrs: {
                                        "csrf-token": _vm.csrfToken,
                                        "job-application": _vm.jobApplication,
                                        "button-text": "Reupload"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "cell shrink" }, [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "button primary",
                                      attrs: {
                                        href:
                                          "" +
                                          _vm.jobApplication.ifact_form
                                            .document_url_cdn,
                                        target: "_blank"
                                      }
                                    },
                                    [_vm._v("Download Form")]
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "cell shrink" }, [
                                  _vm._v(
                                    "\n                                Uploaded: " +
                                      _vm._s(
                                        _vm.convertDate(
                                          _vm.jobApplication.ifact_form.modified
                                        )
                                      ) +
                                      "\n                            "
                                  )
                                ])
                              ]
                            )
                          ]
                        )
                  ])
                ])
              : _c("div", [
                  _c(
                    "p",
                    [
                      _vm._v("\n                    Not Available "),
                      _c("br"),
                      _vm._v(" "),
                      _c("ifact-form-upload-modal", {
                        ref: "uploadIfactForm",
                        attrs: {
                          "csrf-token": _vm.csrfToken,
                          "job-application": _vm.jobApplication,
                          "button-text": "Upload Manually"
                        }
                      })
                    ],
                    1
                  )
                ])
          ])
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "AccordionItem",
        [
          _c("template", { slot: "accordion-trigger" }, [
            _c("strong", [_vm._v("Introduction")]),
            _vm._v(" "),
            _vm.jobApplication.user.introduce_yourself_percent_complete !== 100
              ? _c("small", [
                  _vm._v("\n                Not Added\n            ")
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("template", { slot: "accordion-content" }, [
            _vm.jobApplication.user.introduce_yourself_percent_complete !== 100
              ? _c("div", [_vm._v("N/A")])
              : _vm._e(),
            _vm._v(" "),
            _vm.jobApplication.user.video_path
              ? _c("div", { staticClass: "mb-4" }, [
                  _c("label", [_vm._v("Video")]),
                  _vm._v(" "),
                  _vm.jobApplication.user.video_path
                    ? _c(
                        "a",
                        {
                          attrs: {
                            target: "_blank",
                            href: "" + _vm.jobApplication.user.video_path_cdn
                          }
                        },
                        [_vm._v(_vm._s(_vm.jobApplication.user.video_path_cdn))]
                      )
                    : _vm._e()
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.jobApplication.user.audio_path
              ? _c("div", [
                  _c("label", [_vm._v("Audio")]),
                  _vm._v(" "),
                  _vm.jobApplication.user.audio_path
                    ? _c(
                        "a",
                        {
                          attrs: {
                            target: "_blank",
                            href: "" + _vm.jobApplication.user.audio_path_cdn
                          }
                        },
                        [_vm._v(_vm._s(_vm.jobApplication.user.audio_path_cdn))]
                      )
                    : _vm._e()
                ])
              : _vm._e()
          ])
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "AccordionItem",
        [
          _c("strong", [_vm._v("Bio")]),
          _vm._v(" "),
          _vm.jobApplication.user.user_detail !== null
            ? _c("template", { slot: "accordion-trigger" }, [
                _vm.jobApplication.user.user_detail
                  .user_detail_profile_question_answers.length == 0
                  ? _c("small", [
                      _vm._v("\n                Not Added\n            ")
                    ])
                  : _vm._e()
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("template", { slot: "accordion-content" }, [
            _vm._v("\n            Bio...\n        ")
          ])
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "AccordionItem",
        [
          _c("template", { slot: "accordion-trigger" }, [
            _c("strong", [_vm._v("Baseline Score")]),
            _vm._v(" "),
            _vm.jobApplication.user.baseline_score === null
              ? _c("small", [
                  _vm._v("\n                Not Available\n            ")
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("template", { slot: "accordion-content" }, [
            _c("div", { staticClass: "grid-x grid-padding-x" }, [
              _c("div", { staticClass: "form-control cell small-12" }, [
                _vm.jobApplication.user.baseline_score !== null
                  ? _c("h2", [
                      _vm._v(
                        "SCORE: " +
                          _vm._s(_vm.jobApplication.user.baseline_score)
                      )
                    ])
                  : _vm._e()
              ])
            ])
          ])
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "AccordionItem",
        [
          _c("template", { slot: "accordion-trigger" }, [
            _c("strong", [_vm._v("Language match")])
          ]),
          _vm._v(" "),
          _c("template", { slot: "accordion-content" }, [
            _c("div", { staticClass: "grid-x grid-padding-x" }, [
              _c(
                "div",
                { staticClass: "form-control cell small-12" },
                [
                  _c("div", { staticClass: "cell small-12" }, [
                    _c("h3", [_vm._v("Required Languages")])
                  ]),
                  _vm._v(" "),
                  _vm._l(
                    _vm.jobApplication.job.requisition.person_specification
                      .person_specification_languages,
                    function(reqLanguage, index) {
                      return _c(
                        "div",
                        { key: "lang" + index, staticClass: "cell small-12" },
                        [
                          _c("div", { staticClass: "grid-x grid-padding-x" }, [
                            _c(
                              "div",
                              { staticClass: "form-control cell small-12" },
                              [
                                _c("label", [_vm._v("Language")]),
                                _vm._v(" "),
                                _c("input", {
                                  attrs: { type: "text", disabled: "" },
                                  domProps: {
                                    value: reqLanguage.language.title
                                  }
                                })
                              ]
                            )
                          ])
                        ]
                      )
                    }
                  )
                ],
                2
              ),
              _vm._v(" "),
              _vm.jobApplication.user.user_detail !== null &&
              _vm.jobApplication.user.user_detail.language_proficiencies !==
                undefined
                ? _c(
                    "div",
                    { staticClass: "form-control cell small-12" },
                    [
                      _c("div", { staticClass: "cell small-12" }, [
                        _c("h3", [_vm._v("Candidate Languages")])
                      ]),
                      _vm._v(" "),
                      _vm._l(
                        _vm.jobApplication.user.user_detail
                          .language_proficiencies,
                        function(cvLanguage, index) {
                          return _c(
                            "div",
                            {
                              key: "lang" + index,
                              staticClass: "cell small-12"
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "grid-x grid-padding-x" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "form-control cell small-6"
                                    },
                                    [
                                      _c("label", [_vm._v("Language")]),
                                      _vm._v(" "),
                                      _c("input", {
                                        attrs: { type: "text", disabled: "" },
                                        domProps: {
                                          value: cvLanguage.language.title
                                            ? cvLanguage.language.title
                                            : ""
                                        }
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "form-control cell small-6"
                                    },
                                    [
                                      _c("label", [_vm._v("Fluency")]),
                                      _vm._v(" "),
                                      _c("input", {
                                        attrs: { type: "text", disabled: "" },
                                        domProps: { value: cvLanguage.fluency }
                                      })
                                    ]
                                  )
                                ]
                              )
                            ]
                          )
                        }
                      )
                    ],
                    2
                  )
                : _vm._e()
            ])
          ])
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "AccordionItem",
        [
          _c("template", { slot: "accordion-trigger" }, [
            _c("strong", [_vm._v("Important Recruiter Notes On Candidate")])
          ]),
          _vm._v(" "),
          _c("template", { slot: "accordion-content" }, [
            _c("div", { staticClass: "cell small-12" }, [
              _c("div", { staticClass: "grid-x grid-padding-x" }, [
                _c("div", { staticClass: "form-control cell small-12" }, [
                  _c("h3", [_vm._v("Notes")]),
                  _vm._v(" "),
                  _c(
                    "ol",
                    _vm._l(_vm.failedJobApplications, function(
                      failedJobApplication
                    ) {
                      return _c(
                        "li",
                        { key: failedJobApplication.id },
                        _vm._l(
                          failedJobApplication.job_application_actions,
                          function(applicationAction) {
                            return _c("span", { key: applicationAction.id }, [
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(applicationAction.failed_message) +
                                  "\n                                "
                              )
                            ])
                          }
                        ),
                        0
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c(
                    "ol",
                    _vm._l(_vm.jobApplication.user.notes, function(note) {
                      return _c("li", { key: note }, [
                        _vm._v(
                          "\n                                " +
                            _vm._s(note.message) +
                            "\n                                "
                        ),
                        _c(
                          "ul",
                          _vm._l(note.uploads, function(upload) {
                            return _c("li", [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href:
                                      "https://res.cloudinary.com/ddznwy1te/image/upload/c_scale,dpr_auto,fl_attachment,q_auto:eco,w_auto/v1/" +
                                      upload.upload,
                                    download: upload.file_name,
                                    target: "_blank"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                                            " +
                                      _vm._s(upload.upload) +
                                      "\n                                        "
                                  )
                                ]
                              )
                            ])
                          }),
                          0
                        )
                      ])
                    }),
                    0
                  )
                ])
              ])
            ])
          ])
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "AccordionItem",
        [
          _c("template", { slot: "accordion-trigger" }, [
            _c("strong", [_vm._v("Comms Templates")])
          ]),
          _vm._v(" "),
          _c("template", { slot: "accordion-content" }, [
            _c("div", { staticClass: "cell small-12" }, [
              _c("div", { staticClass: "grid-x grid-padding-x" }, [
                _c("div", { staticClass: "form-control cell small-12" }, [
                  _c(
                    "ol",
                    _vm._l(_vm.comms, function(comm, index) {
                      return _c(
                        "li",
                        {
                          key: "comms" + index,
                          staticStyle: { "margin-top": "10px" }
                        },
                        [
                          _vm._v(
                            "\n                                " +
                              _vm._s(comm.title) +
                              ":"
                          ),
                          _c("br"),
                          _vm._v(" "),
                          comm.email
                            ? _c(
                                "a",
                                {
                                  staticStyle: { "margin-right": "20px" },
                                  attrs: {
                                    target: "blank",
                                    href:
                                      "/recruiter/active-requisitions/system-comms/" +
                                      index +
                                      "/" +
                                      _vm.jobApplication.id +
                                      "/email"
                                  }
                                },
                                [_vm._v("Email")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          comm.sms
                            ? _c(
                                "a",
                                {
                                  staticStyle: { "margin-right": "20px" },
                                  attrs: {
                                    target: "blank",
                                    href:
                                      "/recruiter/active-requisitions/system-comms/" +
                                      index +
                                      "/" +
                                      _vm.jobApplication.id +
                                      "/sms"
                                  }
                                },
                                [_vm._v("SMS")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          comm.whatsapp
                            ? _c(
                                "a",
                                {
                                  attrs: {
                                    target: "blank",
                                    href:
                                      "/recruiter/active-requisitions/system-comms/" +
                                      index +
                                      "/" +
                                      _vm.jobApplication.id +
                                      "/sms"
                                  }
                                },
                                [_vm._v("Whatsapp")]
                              )
                            : _vm._e()
                        ]
                      )
                    }),
                    0
                  )
                ])
              ])
            ])
          ])
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "AccordionItem",
        [
          _c("template", { slot: "accordion-trigger" }, [
            _c("strong", [_vm._v("Candidate Communications")])
          ]),
          _vm._v(" "),
          _c("template", { slot: "accordion-content" }, [
            _c("div", { staticClass: "cell small-12" }, [
              _c("div", { staticClass: "grid-x grid-padding-x" }, [
                _c("div", { staticClass: "form-control cell small-12" }, [
                  _vm.jobApplication.job_application_communications
                    ? _c("table", { staticClass: "unstriped" }, [
                        _c("thead", [
                          _c("tr", [
                            _c("th", [_vm._v("Subject")]),
                            _vm._v(" "),
                            _c("th", [_vm._v("Type")]),
                            _vm._v(" "),
                            _c("th", [_vm._v("Recipient")]),
                            _vm._v(" "),
                            _c("th", [_vm._v("Date Sent")])
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "tbody",
                          _vm._l(
                            _vm.jobApplication.job_application_communications,
                            function(comm) {
                              return _c(
                                "tr",
                                { key: "commcandidate" + comm.id },
                                [
                                  _c("td", [
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          target: "blank",
                                          href:
                                            "/recruiter/active-requisitions/communications-log/" +
                                            comm.id
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                                            " +
                                            _vm._s(comm.subject) +
                                            "\n                                        "
                                        )
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [_vm._v(_vm._s(comm.type))]),
                                  _vm._v(" "),
                                  _c("td", [_vm._v(_vm._s(comm.recipient))]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(_vm.convertDate(comm.created))
                                    )
                                  ])
                                ]
                              )
                            }
                          ),
                          0
                        )
                      ])
                    : _vm._e()
                ])
              ])
            ])
          ])
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "AccordionItem",
        [
          _c("template", { slot: "accordion-trigger" }, [
            _c("strong", [_vm._v("Additional Documents")])
          ]),
          _vm._v(" "),
          _c("template", { slot: "accordion-content" }, [
            _c("div", { staticClass: "cell small-12" }, [
              _c("div", { staticClass: "grid-x grid-padding-x" }, [
                _c("div", { staticClass: "form-control cell small-12" }, [
                  _vm.jobApplication.user.user_documents
                    ? _c("table", { staticClass: "unstriped" }, [
                        _c("thead", [
                          _c("tr", [
                            _c("th", [_vm._v("Title")]),
                            _vm._v(" "),
                            _c("th", [_vm._v("Document")])
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "tbody",
                          _vm._l(
                            _vm.jobApplication.user.user_documents,
                            function(doc, index) {
                              return _c(
                                "tr",
                                { key: "doc-" + doc.id + "-" + index },
                                [
                                  _c("td", [
                                    _vm._v(
                                      "\n                                        " +
                                        _vm._s(doc.title) +
                                        "\n                                    "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          target: "blank",
                                          href: _vm.s3Url(doc.path)
                                        }
                                      },
                                      [_c("i", { staticClass: "fa fa-eye" })]
                                    )
                                  ])
                                ]
                              )
                            }
                          ),
                          0
                        )
                      ])
                    : _vm._e()
                ])
              ])
            ])
          ])
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5d57a770", { render: render, staticRenderFns: staticRenderFns })
  }
}